var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentPencilEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5V21H4.5V3H12V1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V21C3 21.3978 3.15804 21.7794 3.43934 22.0607C3.72064 22.342 4.10218 22.5 4.5 22.5H16.5C16.8978 22.5 17.2794 22.342 17.5607 22.0607C17.842 21.7794 18 21.3978 18 21V16.5H16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.155 4.32L19.68 1.845C19.4557 1.62513 19.1541 1.50197 18.84 1.50197C18.5259 1.50197 18.2243 1.62513 18 1.845L7.5 12.345V16.5H11.6475L22.1475 6C22.3674 5.77569 22.4905 5.4741 22.4905 5.16C22.4905 4.8459 22.3674 4.54431 22.1475 4.32H22.155ZM11.025 15H9V12.975L16.08 5.8875L18.1125 7.92L11.025 15ZM19.17 6.8625L17.1375 4.83L18.84 3.1275L20.8725 5.16L19.17 6.8625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentPencilEdit);
export default __webpack_public_path__ + "static/media/ic-document-pencil-edit.ea3e4bbd8ae2f8d0f2aab9e0b03f5276.svg";
export { ForwardRef as ReactComponent };